function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconsTotalAccounts = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 51.722,
    viewBox: "0 0 55 51.722",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Icons/total accounts",
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17679"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 51021",
    d: "M158.382 114h-51.764a1.616 1.616 0 0 0-1.618 1.616v11.314h55v-11.314a1.616 1.616 0 0 0-1.618-1.616zm-35.588 8.082h-9.706a1.616 1.616 0 1 1 0-3.233h9.706a1.616 1.616 0 1 1 0 3.233zm29.118 0H132.5a1.616 1.616 0 1 1 0-3.233h19.412a1.616 1.616 0 1 1 0 3.233zm-29.118 14.547a1.616 1.616 0 1 0 1.618 1.616 1.618 1.618 0 0 0-1.618-1.617zM105 164.106a1.616 1.616 0 0 0 1.618 1.616h51.765a1.616 1.616 0 0 0 1.617-1.616v-33.943h-55zm30.735-27.477h12.941a1.616 1.616 0 1 1 0 3.233h-12.941a1.616 1.616 0 1 1 0-3.233zm0 6.465h12.941a1.616 1.616 0 1 1 0 3.233h-12.941a1.616 1.616 0 1 1 0-3.233zm0 6.465h12.941a1.616 1.616 0 1 1 0 3.233h-12.941a1.616 1.616 0 1 1 0-3.233zm-12.941-6.465a4.849 4.849 0 1 1 4.853-4.849 4.856 4.856 0 0 1-4.853 4.849 8.094 8.094 0 0 1 8.088 8.082 1.616 1.616 0 0 1-1.618 1.616h-12.94a1.616 1.616 0 0 1-1.618-1.616 8.094 8.094 0 0 1 8.088-8.082zm-6.471 12.93h32.353a1.616 1.616 0 1 1 0 3.233h-32.353a1.616 1.616 0 1 1 0-3.233zm6.471-9.7a4.863 4.863 0 0 0-4.576 3.233h9.153a4.863 4.863 0 0 0-4.577-3.231z",
    transform: "translate(-105 -114)",
    style: {
      fill: "#fff"
    }
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconsTotalAccounts);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Icons_total accounts.5e07772d2e7a583ef22f3de93043db23.svg";